import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryChips = ({ categories, selectedCategory, onCategorySelect }) => {
  // Enhanced category icon mapping with more comprehensive coverage
  const categoryIcons = {
    'mindfulness-meditation': 'Brain',
    'yoga-movement': 'Activity',
    'yoga-studio': 'Activity',
    'energy-healing': 'Zap',
    'complementary-therapies': 'Heart',
    'nutrition-wellness': 'Apple',
    'spirituality-esoterica': 'Star',
    'sound-breathwork': 'Music',
    'coaching-development': 'Users',
    'creative-therapy': 'Palette',
    'retreats-immersions': 'Mountain',
    'nature-eco-therapy': 'TreePine',
    'ceremonies-community': 'Users2',
    'training-professional': 'GraduationCap',
    'courses': 'BookOpen',
    'circles': 'Circle',
    'wellness-center': 'Heart',
    'wellness-centre': 'Heart',
    'holistic-health': 'Sparkles',
    'alternative-medicine': 'Plus',
    'fitness': 'Dumbbell',
    'spa-beauty': 'Flower',
    'counselling-therapy': 'MessageCircle',
    'massage-therapy': 'Hand',
    'acupuncture': 'Target',
    'reiki-healing': 'Zap',
    'life-coaching': 'Users',
    'meditation': 'Brain',
    'pilates': 'Activity',
    'aromatherapy': 'Flower2',
    'crystal-healing': 'Gem',
    'nutrition': 'Apple',
    'personal-training': 'Dumbbell',
    'mental-health': 'Brain',
    'spiritual-guidance': 'Star',
    'reflexology': 'Hand'
  };

  // Enhanced function to get appropriate icon for category
  const getCategoryIcon = (category) => {
    if (!category) return 'Tag';
    
    // Try exact slug match first
    if (categoryIcons?.[category?.slug]) {
      return categoryIcons?.[category?.slug];
    }
    
    // Try partial matches based on category name
    const categoryName = category?.name?.toLowerCase() || '';
    const categorySlug = category?.slug?.toLowerCase() || '';
    
    if (categoryName?.includes('yoga') || categorySlug?.includes('yoga')) return 'Activity';
    if (categoryName?.includes('meditation') || categorySlug?.includes('meditation')) return 'Brain';
    if (categoryName?.includes('wellness') || categorySlug?.includes('wellness')) return 'Heart';
    if (categoryName?.includes('healing') || categorySlug?.includes('healing')) return 'Zap';
    if (categoryName?.includes('therapy') || categorySlug?.includes('therapy')) return 'Heart';
    if (categoryName?.includes('coaching') || categorySlug?.includes('coaching')) return 'Users';
    if (categoryName?.includes('nutrition') || categorySlug?.includes('nutrition')) return 'Apple';
    if (categoryName?.includes('fitness') || categorySlug?.includes('fitness')) return 'Dumbbell';
    if (categoryName?.includes('spiritual') || categorySlug?.includes('spiritual')) return 'Star';
    if (categoryName?.includes('massage') || categorySlug?.includes('massage')) return 'Hand';
    
    // Default fallback
    return 'Sparkles';
  };

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-heading font-semibold text-foreground">
          Browse Categories
        </h2>
        <button
          onClick={() => onCategorySelect('all')}
          className="text-sm text-primary hover:text-primary/80 font-body transition-gentle"
        >
          View All
        </button>
      </div>
      
      {/* Enhanced horizontal scrollable tabs */}
      <div className="flex overflow-x-auto scrollbar-hide space-x-3 pb-2">
        {/* All Categories Tab */}
        <button
          onClick={() => onCategorySelect('all')}
          className={`flex items-center space-x-2 px-4 py-2 rounded-full whitespace-nowrap transition-organic ${
            selectedCategory === 'all' ?'bg-primary text-primary-foreground shadow-lg' :'bg-card text-card-foreground hover:bg-primary/10 hover:shadow-md'
          }`}
        >
          <Icon name="Grid3x3" size={16} />
          <span className="text-sm font-body font-medium">All</span>
        </button>
        
        {/* Individual Category Tabs */}
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategorySelect(category?.id)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-full whitespace-nowrap transition-organic ${
              selectedCategory === category?.id
                ? 'bg-primary text-primary-foreground shadow-lg'
                : 'bg-card text-card-foreground hover:bg-primary/10 hover:shadow-md'
            }`}
          >
            <Icon name={getCategoryIcon(category)} size={16} />
            <span className="text-sm font-body font-medium">{category?.name}</span>
          </button>
        ))}
      </div>
      
      {/* Category count indicator */}
      {categories?.length > 0 && (
        <div className="mt-2 text-center">
          <p className="text-xs text-muted-foreground">
            {selectedCategory === 'all' 
              ? `Browse ${categories?.length} wellness categories`
              : `${categories?.find(c => c?.id === selectedCategory)?.name || 'Category'} services`
            }
          </p>
        </div>
      )}
    </div>
  );
};

export default CategoryChips;